// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3cNgo","title":"ClientReferral_title__2Bwzw","itemText":"ClientReferral_itemText__2GUUf"};